module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-222.7f4f0f68.svg";